
    import './styles.scoped.css';
    export default {
  "content-header-sticky": "awsui_content-header-sticky_szx2o_8sakc_9"
};
  